import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../utils/config-service';
import { GlobalName } from '../utils/global-name';

@Injectable({
  providedIn: 'root'
})
export class ProgramService {

  url=ConfigService.toApiUrl("programs/");

  constructor(private http:HttpClient) { }

    getAll(classroomId:any){
    return this.http.get<any[]>(`${this.url}?classroom_id=${classroomId}`,ConfigService.addAction('list'));
  }
 
  getByState(state:any){
    return this.http.get<any[]>(`${ConfigService.toApiUrl("programs-by-state")}/${state}`,ConfigService.addAction('list'));
  }

  store(ressource:any){
    return this.http.post<any>(`${this.url}`, ressource,
     ConfigService.addAction('add'));
  }

  update(id:any,ressource:any){
    // apiResource n'expose que PUT|PATCH sur /{id}. Le spoofing par _method
    // fonctionne, mais l'affectation d'une propriete sur un FormData ne cree
    // aucun champ : la requete partait alors en POST nu et repondait 405.
    if (ressource instanceof FormData) {
      ressource.append('_method','PUT');
      return this.http.post<any>(`${this.url}${id}`, ressource, ConfigService.addAction('edit'));
    }
    return this.http.put<any>(`${this.url}${id}`, ressource, ConfigService.addAction('edit'));
  }
  delete(id:any){
    return this.http.delete<any>(`${this.url}${id}`,
     ConfigService.addAction('delete'));
  }

  get(id:any){
    return this.http.get<any>(`${this.url}${id}`,
     ConfigService.addAction('show'));
  }

  setState(id:any,state:any){
    return this.http.get<any[]>(`${ConfigService.toApiUrl("programs-set-state")}/${id}/state/${state}`,ConfigService.addAction('status'));
  }

  getProfessorCurrentWeekPrograms(classroom_id?:any){
    return this.http.get<any[]>(`${ConfigService.toApiUrl("programs-professor-current-week")}?classroom_id=${classroom_id}`,ConfigService.addAction('list'));
  }
  getProfessorDayPrograms(dayCode:any){
    return this.http.get<any[]>(`${ConfigService.toApiUrl("programs-professor-day")}/${dayCode}`,ConfigService.addAction('list'));
  }

  getStudentCurrentWeekPrograms(){
    return this.http.get<any[]>(`${ConfigService.toApiUrl("programs-student-current-week")}`,ConfigService.addAction('list'));
  }
  getStudentDayPrograms(dayCode:any,studentId?:any){

    if (studentId==undefined) {
      return this.http.get<any[]>(`${ConfigService.toApiUrl("programs-student-day")}/${dayCode}`,ConfigService.addAction('list'));

    }else{
      return this.http.get<any[]>(`${ConfigService.toApiUrl("programs-student-day")}/${dayCode}?studentId=${studentId}`,ConfigService.addAction('list'));

    }
  }
  getStudentDaytextbook(dayCode:any,date:any,studentId?:any){
    if (studentId==undefined) {
      return this.http.get<any[]>(`${ConfigService.toApiUrl("programs-student-textbook-day")}/${dayCode}/${date}`,ConfigService.addAction('list'));

    }else{
      return this.http.get<any[]>(`${ConfigService.toApiUrl("programs-student-textbook-day")}/${dayCode}/${date}?studentId=${studentId}`,ConfigService.addAction('list'));

    }
  }
}
